export default {
      id: "ic_tjk_arrow_down-usage",
      viewBox: "0 0 10 7",
      url: "/" + "images/icons.3.109.2.svg#ic_tjk_arrow_down-usage",
      toString: function () {
        return this.url;
      }
    }